import request from '@/utils/request'
import axios from 'axios'

/************************************营销通用接口*******************************************/
// （商场、楼层、店铺）级联数据
export async function api_getShopTreeData(params) {
  return request({
    url: '/rest/store/union/list',
    method: 'get',
    params,
  })
}




/************************************优惠券列表*******************************************/
// 获取优惠券列表数据
export async function api_postCouponList(params) {
  return request({
    url: '/rest/market/coupon/template/page',
    method: 'get',
    params,
  })
}

// 创建优惠券
export async function api_postAddCoupon(data) {
  return request({
    url: '/rest/market/coupon/template',
    method: 'post',
    data,
  })
}

// 优惠券详情
export async function api_getCouponDetail(params) {
  return request({
    url: '/rest/market/coupon/template',
    method: 'get',
    params,
  })
}

// 优惠券详情编辑回显版
export async function api_getCouponDetailV2(params) {
  return request({
    url: '/rest/market/coupon/template/v2',
    method: 'get',
    params,
  })
}
// 优惠券编辑
export async function api_putCouponUpdateV2(data) {
  return request({
    url: '/rest/market/coupon/template',
    method: 'put',
    data,
  })
}

// 优惠券停用启用
export async function api_putUpdateStatusCoupon(data) {
  return request({
    url: '/rest/market/coupon/template/switch',
    method: 'put',
    data,
  })
}

// 券弃用
export async function api_putCouponDiscard(params) {
  return request({
    url: '/rest/market/coupon/template/discard',
    method: 'put',
    params,
  })
}

// 下载券码导入模板
export async function api_getCouponCodeImportTemplate(params) {
  return request({
    url: '/rest/market/couponcode/template/download',
    method: 'get',
    params,
    responseType: 'blob',
  })
}

// 券码导入
export async function api_postCouponCodeImport(data) {
  let formData = new FormData()
  formData.append('excel', data.file)
  return request({
    url: `/rest/market/couponcode/generate?id=${data.id}`,
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    data: formData,
  })
}

// 获取画像列表数据
export async function api_getPortrayalData(params) {
  return request({
    url: '/rest/member/listPortrait',
    method: 'get',
    params,
  })
}
// 获取码库列表数据
export async function api_getCouponCodeList(data) {
  return request({
    url: '/rest/market/coupon/template/coupon/stock/page',
    method: 'POST',
    data,
  })
}

// 码库核销模版下载
export async function api_getCouponCodeDownload(params) {
  return request({
    url: '/rest/market/couponcode/used/import/download',
    method: 'get',
    params,
    responseType: 'blob',
  })
}

// 核销数据导入
export async function api_postCouponCodeImportCouponUsed(data) {
  let formData = new FormData()
  formData.append('excel', data.file)
  return request({
    url: `/rest/market/couponcode/importCouponUsed`,
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    responseType: 'arraybuffer', 
    data: formData,
  })
}

// 码库 导出
export async function api_postCouponCodeExport(data) {
  return request({
    url: '/rest/market/coupon/template/export/coupon/stock/page',
    method: 'POST',
    data,
    responseType: 'blob',
  })
}
/************************************抵扣券*******************************************/

// 获取抵扣券列表
export async function api_getDeductCouponList(params) {
  return request({
    url: '/rest/market/deduct/coupon/template/page',
    method: 'get',
    params,
  })
}

// 创建抵扣券
export async function api_postDeductCouponCreate(data) {
  return request({
    url: '/rest/market/deduct/coupon/template',
    method: 'post',
    data,
  })
}

// 编辑抵扣券
export async function api_putDeductCouponUpdate(data) {
  return request({
    url: '/rest/market/deduct/coupon/template',
    method: 'put',
    data,
  })
}

// 抵扣券下拉列表
export async function api_getDeductCouponSelect(params) {
  return request({
    url: '/rest/market/deduct/coupon/template/available/list',
    method: 'get',
    params,
  })
}
// 抵扣券详情
export async function api_getDeductCouponTemplate(params) {
  return request({
    url: '/rest/market/deduct/coupon/template',
    method: 'get',
    params,
  })
  }

  // 抵扣券购券记录
export async function api_getDeductCouponSalePage(params) {
  return request({
    url: '/rest/market/deduct/coupon/sale/page',
    method: 'get',
    params,
  })
  }

  // 抵扣券核销记录
export async function api_getDeductCouponUsedPage(params) {
  return request({
    url: '/rest/market/deduct/coupon/used/page',
    method: 'get',
    params,
  })
  }

    // 抵扣券购券记录导出
export async function api_getDeductCouponSaleExport(data) {
  return request({
    url: '/rest/market/deduct/coupon/export/sale/page/v2',
    method: 'post',
    data,
    responseType: 'blob',
  })
  }


  // 抵扣券核销记录导出
export async function api_getDeductCouponUsedExport(data) {
  return request({
    url: '/rest/market/deduct/coupon/export/used/coupons',
    method: 'post',
    data,
    responseType: 'blob',
  })
  }

/************************************发券*******************************************/
// 发券任务列表
export async function api_getCouponGrantList(params) {
  return request({
    url: '/rest/market/coupon/task/page',
    method: 'get',
    params,
  })
}

// 发券任务列表new
export async function api_getNewCouponGrantList(params) {
  return request({
    url: 'rest/market/coupon/task/manual/page',
    method: 'get',
    params,
  })
}

// 创建发券任务
export async function api_postCouponGrantAdd(data) {
  return request({
    url: '/rest/market/coupon/task',
    method: 'post',
    data,
  })
}

// 删除发券任务
export async function api_delCouponGrant(params) {
  return request({
    url: '/rest/market/coupon/task',
    method: 'delete',
    params,
  })
}



/************************************优惠券记录*******************************************/
// 获取优惠券记录列表数据
export async function api_postCouponRecordList(data) {
  return request({
    url: '/rest/market/coupon/activity/page',
    method: 'post',
    data,
  })
}

// 获取活动类型数据
export async function api_getActivityTypeData(params) {
  return request({
    url: '/rest/market/coupon/activity/type/list',
    method: 'get',
    params,
  })
}








/************************************活动列表*******************************************/
// 获取活动列表数据
export async function api_getActivityList(params) {
  return request({
    url: '/rest/activity/page',
    method: 'get',
    params,
  })
}

// 创建活动
export async function api_postActivityAdd(data) {
  return request({
    url: '/rest/activity',
    method: 'post',
    data,
  })
}

// 更新活动
export async function api_postActivityUpdate(data) {
  return request({
    url: '/rest/activity',
    method: 'put',
    data,
  })
}

// 活动基本信息详情数据
export async function api_getActivityBaseInfo(params) {
  return request({
    url: '/rest/activity',
    method: 'get',
    loading: true,
    params,
  })
}

// 获取奖品数据
export async function api_getPrizesData(params) {
  return request({
    url: '/rest/activity/prize',
    method: 'get',
    params,
  })
}

// 添加奖品
export async function api_postPrizeAdd(data) {
  return request({
    url: '/rest/activity/prize',
    method: 'post',
    data,
  })
}

// 修改奖品
export async function api_postPrizeUpdate(data) {
  return request({
    url: '/rest/activity/prize',
    method: 'put',
    data,
  })
}

// 删除奖品
export async function api_postPrizeDel(params) {
  return request({
    url: '/rest/activity/prize',
    method: 'delete',
    params,
  })
}

// 创建活动（领券中心类型）
export async function api_postAddCouponCenter(data) {
  return request({
    url: '/rest/activity/coupon',
    method: 'post',
    data,
  })
}

// 更新活动（领券中心类型）
export async function api_putUpdateCouponCenter(data) {
  return request({
    url: '/rest/activity/coupon',
    method: 'put',
    data,
  })
}

// 导出领券活动领取记录
export async function api_getExportCouponCenterRecord(params) {
  return request({
    url: '/rest/activity/export/record/list',
    method: 'get',
    params,
    responseType: 'blob',
  })
}

// 创建活动（售券类型）
export async function api_postAddCouponSell(data) {
  return request({
    url: '/rest/activity/coupon/sale',
    method: 'post',
    data,
  })
}

// 更新活动（售券类型）
export async function api_putUpdateCouponSell(data) {
  return request({
    url: '/rest/activity/coupon/sale',
    method: 'put',
    data,
  })
}

// 更改活动状态
export async function api_putUpdateActivityStatus(params) {
  return request({
    url: '/rest/activity/switch',
    method: 'put',
    params,
  })
}

// 中奖记录
export async function api_getWinningRecord(params) {
  return request({
    url: '/rest/activity/record/list',
    method: 'get',
    params,
  })
}

// 导出中奖记录
export async function api_postWinningRecordExport(data) {
  return request({
    url: '/rest/activity/record/export',
    method: 'post',
    data,
    responseType: 'blob',
  })
}

// 下载隐藏券二维码
export async function api_getHideActiveCouponCode(params) {
  return axios({
    url: '/rest/activity/qrcode/download',
    method: 'get',
    params,
    responseType: 'blob',
  })
}

// 下载大转盘、刮刮乐活动二维码
export async function api_getActiveCode(params) {
  return axios({
    url: '/rest/activity/miniCode/download',
    method: 'get',
    params,
    responseType: 'blob',
  })
}



/************************************核销列表*******************************************/

// 核销列表
export async function api_getWriteOffList(params) {
  return request({
    url: '/rest/activity/writeoff/list',
    method: 'get',
    params,
  })
}



/************************************分账系统-发券*******************************************/
// 列表
export async function api_getAccountCouponGrantList(params) {
  return request({
    url: '/rest/activity/order/coupon/page',
    method: 'get',
    params,
  })
}

// 开关优惠券
export async function api_putAccountCouponGrantSwitch(params) {
  return request({
    url: '/rest/activity/order/coupon/switch',
    method: 'put',
    params,
  })
}

// 创建
export async function api_postAccountCouponGrantAdd(data) {
  return request({
    url: '/rest/activity/order/coupon',
    method: 'post',
    data,
  })
}




/************************************优惠券对账中心*******************************************/
// 券购买记录
export async function api_getCouponBuyRecordList(params) {
  return request({
    url: '/rest/market/coupon/sale/page',
    method: 'get',
    params,
  })
}

// 券购买记录导出
export async function api_postCouponBuyRecordListExport(data) {
  return request({
    url: '/rest/market/coupon/export/sale/page',
    method: 'post',
    data,
    responseType: 'blob',
  })
}


// 券核销记录
export async function api_getCheckCancelRecordList(params) {
  return request({
    url: '/rest/market/coupon/used/page',
    method: 'get',
    params,
  })
}

// 券核销记录导出
export async function api_postCheckCancelRecordListExport(data) {
  return request({
    url: '/rest/market/coupon/export/used/coupons',
    method: 'post',
    data,
    responseType: 'blob',
  })
}

// 券购买记录导出V2
export async function api_postCouponBuyRecordListExportV2(data) {
  return request({
    url: '/rest/market/coupon/export/sale/page/v2',
    method: 'post',
    data,
    responseType: 'blob',
  })
}

/************************************储值卡*******************************************/
// 列表
export async function api_getValueCardList(params) {
  return request({
    url: '/rest/storedcard/template/page',
    method: 'get',
    params,
  })
}
// 创建
export async function post_getValueCardAdd(data) {
  return request({
    url: '/rest/storedcard/template/create',
    method: 'post',
    data,
  })
}


// 详情
export async function api_getValueCardDetail(params) {
  return request({
    url: '/rest/storedcard/template/get',
    method: 'get',
    params,
  })
}

// 编辑
export async function api_putValueCardEdit(params) {
  return request({
    url: '/rest/storedcard/template/update',
    method: 'put',
    params,
  })
}

// 修改状态
export async function api_putValueCardStatus(params) {
  return request({
    url: '/rest/storedcard/template/update/effective',
    method: 'put',
    params,
  })
}

// 储值卡购卡记录列表
export async function api_postBuyCardRecordList(data) {
  return request({
    url: '/rest/storedcard/record/buy/page',
    method: 'post',
    data,
  })
}

// 储值卡购卡记录导出
export async function api_postBuyCardRecordExport(data) {
  return request({
    url: '/rest/storedcard/record/export/buy/page',
    method: 'post',
    data,
    responseType: 'blob',
  })
}

// 储值卡核销记录列表
export async function api_postCheckCancelCardRecordList(data) {
  return request({
    url: '/rest/storedcard/record/consume/page',
    method: 'post',
    data,
  })
}

// 储值卡核销记录导出
export async function api_postCheckCancelCardRecordExport(data) {
  return request({
    url: '/rest/storedcard/record/export/consume/page',
    method: 'post',
    data,
    responseType: 'blob',
  })
}

// 下载小程序二维码
export async function api_getDownloadMiniCode(params) {
  return axios({
    url: '/rest/storedcard/template/miniCode/download',
    method: 'get',
    params,
    responseType: 'blob',
  })
}
// 拉取券中台储值卡列表
export async function api_getVcCardList(params) {
  return request({
    url: '/rest/vc/storedcard/sync',
    method: 'get',
    params,
  })
}

// 同步券中台储值卡
export async function api_getVcCardSync(data) {
  return request({
    url: '/rest/vc/post/storedcard/template/sync',
    method: 'post',
    data,
  })
}

/************************************礼品券*******************************************/
// 列表
export async function api_getGiftCouponList(params) {
  return request({
    url: '/rest/market/coupon/gift/template/page',
    method: 'get',
    params,
  })
}

// 创建
export async function api_postGiftCouponAdd(data) {
  return request({
    url: '/rest/market/coupon/gift/template',
    method: 'post',
    data,
  })
}
// 编辑
export async function api_putGiftCouponUpdate(data) {
  return request({
    url: '/rest/market/coupon/gift/template',
    method: 'put',
    data,
  })
}

// 获取礼品券编辑回显数据
export async function api_getGiftCouponDetailV2(params) {
  return request({
    url: '/rest/market/coupon/gift/template/v2',
    method: 'get',
    params,
  })
}


// 获取礼品券详情数据
export async function api_getGiftCouponDetail(params) {
  return request({
    url: '/rest/market/coupon/gift/template',
    method: 'get',
    params,
  })
}

// 礼品券核销记录
export async function api_getGiftCouponCheckRecordList(params) {
  return request({
    url: '/rest/market/gift/coupon/used/page',
    method: 'get',
    params,
  })
}

// 礼品券核销记录导出
export async function api_postGiftCouponCheckRecordListExport(data) {
  return request({
    url: '/rest/market/gift/coupon/export/used/page',
    method: 'post',
    data,
    responseType: 'blob',
  })
}

// 礼品券购券记录
export async function api_getGiftCouponBuyRecordList(params) {
  return request({
    url: '/rest/market/gift/coupon/sale/page',
    method: 'get',
    params,
  })
}

// 礼品券购券记录导出
export async function api_postGiftCouponBuyRecordListExport(data) {
  return request({
    url: '/rest/market/gift/coupon/export/sale/page',
    method: 'post',
    data,
    responseType: 'blob',
  })
}

// 礼品券弃用
export async function api_putGiftCouponDiscard(params) {
  return request({
    url: '/rest/market/coupon/gift/template/discard',
    method: 'put',
    params,
  })
}
// 礼品券停用启用
export async function api_putUpdatestatusGiftCoupon(data) {
  return request({
    url: '/rest/market/coupon/gift/template/switch',
    method: 'put',
    data,
  })
}

// 礼品券停用启用
export async function api_getCouponCodeTemplate(params) {
  return request({
    url: '/rest/market/giftcouponcode/template/download',
    method: 'get',
    params,
    responseType: 'blob',
  })
}
// 券码导入
export async function api_postCodeImport(data) {
  let formData = new FormData()
  formData.append('excel', data.file)
  return request({
    url: `/rest/market/giftcouponcode/generate?id=${data.id}`,
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    data: formData,
  })
}
/************************************报名活动*******************************************/

// 创建报名活动
export async function api_postApplyActivityAdd(data) {
  return request({
    url: '/rest/activity/sign/up/create',
    method: 'post',
    data,
  })
}

// 更新报名活动
export async function api_postApplyActivityUpdate(data) {
  return request({
    url: '/rest/activity/update/ticket',
    method: 'post',
    data,
  })
}

// 获取报名活动门票数据
export async function api_getApplyTicketList(params) {
  return request({
    url: '/rest/ticket/list',
    method: 'get',
    params,
  })
}

// 删除单张门票
export async function api_putTicketDel(params) {
  return request({
    url: '/rest/ticket/delete/one',
    method: 'put',
    params,
  })
}

// 删除全部门票
export async function api_putTicketDelAll(params) {
  return request({
    url: '/rest/ticket/delete/all',
    method: 'put',
    params,
  })
}

// 添加单张门票
export async function api_postTicketAdd(data) {
  return request({
    url: '/rest/ticket/create',
    method: 'post',
    data,
  })
}

// 更新单张门票
export async function api_postTicketUpdate(data) {
  return request({
    url: '/rest/ticket/update',
    method: 'post',
    data,
  })
}

// 门票购买记录
export async function api_getApplyTicketBuyRecord(params) {
  return request({
    url: '/rest/ticket/bought',
    method: 'get',
    params,
  })
}

// 活动报名记录导出
export async function api_getTicketBoughtExportRecord(params) {
  return request({
    url: '/rest/ticket/bought/export',
    method: 'get',
    params,
    responseType: 'blob',
  })
}
// 门票退款(现金+积分)
export async function api_getRefund(params) {
  return request({
    url: '/rest/ticket/refund',
    method: 'get',
    params,
  })
}

// 门票退款(纯积分)
export async function api_getRefundPoint(params) {
  return request({
    url: '/rest/ticket/refundPoint',
    method: 'get',
    params,
  })
}



/************************************发券活动*******************************************/
// 创建发券活动
export async function api_postSendCouponAdd(data) {
  return request({
    url: '/rest/activity/coupon/distribution',
    method: 'post',
    data,
  })
}

// 更新发券活动
export async function api_putSendCouponUpdate(data) {
  return request({
    url: '/rest/activity/coupon/distribution',
    method: 'put',
    data,
  })
}

// 发券活动领取记录
export async function api_getSendCouponGetRecord(params) {
  return request({
    url: '/rest/market/coupon/payment/coupon/distribution/page',
    method: 'get',
    params,
  })
}


// 手动发券记录导出
export async function api_getMarketCouponTaskExportRecord(params) {
  return request({
    url: '/rest/market/coupon/task/manual/page/export',
    method: 'get',
    params,
    responseType: 'blob',
  })
}
/************************************秒杀活动*******************************************/
// 创建秒杀活动
export async function api_postSeckillAdd(data) {
  return request({
    url: '/rest/activity/flash/sale',
    method: 'post',
    data,
  })
}

// 更新秒杀活动
export async function api_putSeckillUpdate(data) {
  return request({
    url: '/rest/activity/flash/sale',
    method: 'put',
    data,
  })
}

// 购买记录列表
export async function api_getSeckillCouponBuyRecordList(params) {
  return request({
    url: '/rest/market/coupon/flash/sale/page',
    method: 'get',
    params,
  })
}

// 活动记录导出接口
 export async function api_getActivityRecordExport(params) {
  return request({
    url: '/rest/market/coupon/export/flash/sale',
    method: 'get',
    params,
    responseType: 'blob',
  })
}

// 活动记录导出接口(售券-礼品券)
export async function api_getExportGiftCoupoonSellRecord(params) {
  return request({
    url: '/rest/market/gift/coupon/export/sale/page',
    method: 'get',
    params,
    responseType: 'blob',
  })
}

/************************************停车券列表*******************************************/
// 停车券列表
export async function api_getParkingCouponList(params) {
  return request({
    url: '/rest/parking/coupon/template/page',
    method: 'get',
    params,
  })
}
// 停车券详情
export async function api_getParkingCouponDatil(params) {
  return request({
    url: '/rest/parking/coupon/template',
    method: 'get',
    params,
  })
}
// 创建停车券
export async function api_postParkingCouponAdd(data) {
  return request({
    url: '/rest/parking/coupon/template',
    method: 'post',
    data,
  })
}
// 修改停车券
export async function api_putParkingCouponUpadte(data) {
  return request({
    url: '/rest/parking/coupon/template',
    method: 'put',
    data,
  })
}
// 停用启用停车券
export async function api_putUpadteStatusParkingCoupon(params) {
  return request({
    url: '/rest/parking/coupon/template/switch',
    method: 'put',
    params,
  })
}


// 停车券核销
export async function api_getParkingCouponRecordList(params) {
  return request({
    url: '/rest/parking/coupon/used/page',
    method: 'get',
    params,
  })
}

/************************************券中台*******************************************/

// 券中台数据列表
export async function api_getCouponeCenterList(params) {
  return request({
    url: '/rest/vc/post/list',
    method: 'get',
    params,
  })
}

// 券中台券下拉数据列表
export async function api_getCouponTemplateList(params) {
  return;
  return request({
    url: '/rest/vc/couponTemplateList',
    method: 'get',
    params,
  })
}
// 券中台券追加
export async function api_getCouponTemplate(params) {
  return request({
    url: '/rest/vc/couponTemplate',
    method: 'get',
    params,
  })
}

// 券中台券拉取同步列表
export async function api_getVcCouponTemplateList(params) {
  return request({
    url: '/rest/vc/couponTemplateList/sync',
    method: 'get',
    params,
  })
}

// 券中台券拉取同步
export async function api_getVcCouponTemplateSync(data) {
  return request({
    url: '/rest/vc/post/template/sync',
    method: 'post',
    data,
  })
}
/************************************手动发券*******************************************/

// 下载模板
export async function api_getDownloadExcel(params) {
  return request({
    url: '/rest/market/coupon/task/download',
    method: 'get',
    params,
    headers: {
      'Content-Type': "application/json;charset=UTF-8"
  },
  responseType: 'blob',
  })
}

// 导入模板
export async function api_getImportExcelExcel(data) {
  let formData = new FormData()
  formData.append('excel', data.file)
  return request({
    url: `/rest/market/coupon/task/importExcel`,
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    data: formData,
  })
}


// 编辑手动发券
export async function api_getUpdateExcel(data) {
  return request({
    url: '/rest/market/coupon/task/update',
    method: 'post',
    data,
  })
}


// 下载模板
export async function api_getCouPonDownloadExcel(params) {
  return request({
    url: 'rest/market/coupon/task/couPonDownload',
    method: 'get',
    params,
    headers: {
      'Content-Type': "application/json;charset=UTF-8"
  },
  responseType: 'blob',
  })
}

// 批量导出活动记录
export async function api_getActivityRecordExportAll(params) {
  return request({
    url: "/rest/activity/batch/export/record/list",
    method: 'get',
    params,
    responseType: 'blob',
  })
}

// 优惠券列表：下载券码
export async function api_postDownloadCouponCode(data) {
  return request({
    url: "/rest/market/couponstock/insert/download",
    method: 'post',
    data,
    responseType: 'blob',
  })
}

// 供应权益列表
export async function api_getWelfareCouponList(params) {
  return request({
    url: "/rest/market/welfare/template/page",
    method: 'get',
    params,
  })
}

//  供应权益商品详情
export async function api_getWelfareItemDetail(params) {
  return request({
    url: "/rest/market/welfare/template",
    method: 'get',
    params,
  })
}

//  供应权益商品编辑
export async function api_putWelfareItemUpdate(data) {
  return request({
    url: "/rest/market/welfare/template",
    method: 'put',
    data,
  })
}

// 所有福利券
export async function api_getWelfareCouponAll(params) {
  return request({
    url: "/rest/market/welfare/template/all",
    method: 'get',
    params,
  })
}

// 券中台拉取福利券列表
export async function api_getVCWelfareCouponList(params) {
  return request({
    url: "/rest/vc/welfare/coupon/sync",
    method: 'get',
    params,
  })
}

// 同步券中台福利券
export async function api_postVCWelfareCouponSync(data) {
  return request({
    url: `/rest/vc/post/welfare/template/sync`,
    method: 'post',
    data,
  })
}

// 福利券模板详情数据
export async function api_getVCWelfareCouponTemplate(params) {
  return request({
    url: `/rest/market/welfare/template/detail`,
    method: 'get',
    params,
  })
}

// 券分享埋点导出
export async function api_getMarketCouponShareExport(params) {
  return request({
    url: "/rest/market/coupon/share/export",
    method: 'get',
    params,
    responseType: 'blob',
  })
}

// 供应权益渠道供应商列表
export async function api_getMarketWelfareChannelList(params) {
  return request({
    url: "/rest/market/welfare/template/channel/list",
    method: 'get',
    params,
  })
}

// 获取活动入口场景list
export async function api_getActivityEntryScene(params) {
  return request({
    url: `/rest/activity/coupon/button`,
    method: 'get',
    params,
  })
}
// 获取权益商品列表
export async function api_getMarketWelfareTemplateList(params) {
  return request({
    url: `/rest/market/welfare/template/list`,
    method: 'get',
    params,
  })
}
// 获取供应商购买记录列表
export async function api_postMarketWelfareOrderPage(data) {
  return request({
    url: `/rest/market/welfare/order/page`,
    method: 'post',
    data,
  })
}
// 获取供应商购买记录列表 -- 导出
export async function api_postWelfareOrderExport(data) {
  return request({
    url: '/rest/market/welfare/order/export',
    method: 'post',
    data,
    responseType: 'blob',
  })
}
/************************************邀友记录*******************************************/


// 获取邀友记录列表
export async function api_getInviteRecordList(params) {
  return request({
    url: `/rest/member/invite/record/page`,
    method: 'get',
    params,
  })
}

// 获取邀友活动列表
export async function api_getInviteActivityRecordList(params) {
  return request({
    url: `/rest/member/invite/activity/statistics`,
    method: 'get',
    params,
  })
}


// 获取售券场景列表
export async function api_getActivityZoneList(params) {
  return request({
    url: `/rest/activity/zone/list`,
    method: 'get',
    params,
  })
}
